// extracted by mini-css-extract-plugin
module.exports = {"versionLink":"version-link-module--version-link--16Vcb","version":"version-link-module--version--3vyIO"};